import React from 'react';
import Slider from 'rc-slider';

class SliderFilter extends React.Component {
  render() {
    return (
      <div>
        <div className="p-l-15 p-r-15 p-b-5">
          <Slider range disabled />
        </div>

        <div className="clearfix p-l-15 p-r-15 p-t-5">
          <div className="pull-left" style={{ width: '8%' }}>
            <span className="ms-wireframe fs-10" style={{ width: '100%' }}>
              <span className="block animated-background" style={{ width: '100%' }}>
                {'\u00A0'}
              </span>
            </span>
          </div>
          <div className="pull-right" style={{ width: '14%' }}>
            <span className="ms-wireframe fs-10" style={{ width: '100%' }}>
              <span className="block animated-background" style={{ width: '100%' }}>
                {'\u00A0'}
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default SliderFilter;
